/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FulfilledTestGroupDto = {
    readonly id?: string;
    readonly name?: string;
    readonly subTitle?: string;
    readonly testGroupType?: FulfilledTestGroupDto.testGroupType;
    readonly letterFromMbAvailable?: boolean;
    readonly order?: number;
    fulfilled?: boolean;
};
export namespace FulfilledTestGroupDto {
    export enum testGroupType {
        SPECIFICATION = 'SPECIFICATION',
        GENERIC = 'GENERIC',
    }
}

